export const SingleLineLoaderSmall = () => {
  return (
    <div className="flex-col justify-center items-end gap-[1vh] inline-flex">
      <div className="w-[6.8vh] h-[1.2vh] justify-center items-center inline-flex">
        <div className="h-0 w-0 dark:w-[6.8vh] custom-pulse-dark dark:h-[1.2vh] bg-neutral-900 opacity-60 rounded-[2vh]" />
      </div>
    </div>
  );
};
